import styled, { css } from 'styled-components'
import { zIndex } from '../../Styles/Metrics'

const FullWidthStyle = css`
  width: 100%;
`

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  ${({ fullWidth }) => fullWidth && FullWidthStyle}
`

export const IconButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  outline: none;
  position: absolute !important;
  top: 0px;
  right: 4px;
  transform: translateY(50%);
  z-index: ${zIndex.tooltip};
  color: ${({ theme }) => theme.primary}
`



// WEBPACK FOOTER //
// ./src/Components/PasswordInput/styles.js